var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{ref:"carousel-modal",attrs:{"id":"carousel-modal","title":_vm.title,"centered":"","hide-footer":_vm.hideFooter}},[_c('b-card-text',{staticClass:"mb-1"},[_c('BasicCarousel',{attrs:{"images":_vm.images}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }